/**
 * Pure helpers for the IMA ad tag URLs (preroll, midroll, postroll).
 * No runtime imports, so `node --test` runs the tests directly.
 */

/**
 * Restricts an ad request to video creatives (ECWD-276): GAM otherwise also
 * delivers audio ads into the video player. Sets `ad_type=video`, replacing a
 * value the configured adserver URL may already carry, so it is never sent twice.
 */
export function videoOnly(url: string): string {
  if (/[?&]ad_type=/.test(url)) {
    return url.replace(/([?&])ad_type=[^&]*/, '$1ad_type=video');
  }
  return url + (url.includes('?') ? '&' : '?') + 'ad_type=video';
}
